import { useCallback } from 'react'
import { toast } from '../store/snackbarStore'

/**
 * Returns a function that copies a URL path to the clipboard
 * and shows a success toast.
 *
 * ```tsx
 * const copyLink = useCopyLink()
 * <IconButton onClick={() => copyLink('/locations/abc-123')}>
 * ```
 */
export function useCopyLink() {
  return useCallback((path: string) => {
    const url = `${window.location.origin}${path}`
    navigator.clipboard.writeText(url).then(
      () => toast.success('Link copied to clipboard'),
      () => toast.error('Failed to copy link'),
    )
  }, [])
}
